module.exports = __webpack_public_path__ + "fonts/araboto-black-webfont.153f237b.ttf";